export class Configuration {
    public static ignoreErrorList: string[] = [
        'RESERVATION_CANCELLED',
        'LEGACY_TOKEN_NOT_FOUND',
        'LEGACY_TOKEN_ERROR',
        'timeout of 0ms exceeded',
        'RESERVATION_IN_BLOCKLISTS',
        'IDV_FAILED',
        'STATUS 403',
        'STATUS 401',
        'STATUS 500',
        'docs-homescreen-gb-container',
        'DOMNodeInsertedFunc',
        'QuotaExceededError',
        'operation was aborted',
        'chrome-extension:',
        "Unexpected token '<'",
        'Cannot redefine property: play',
        'leadflows.js',
        'ceCurrentVideo',
        'safari-extension:',
        'safari-web-extension',
    ];

    public static getCancellationPolicyURL = (): string => {
        return `https://www.vacasa.com/support/worry-free-change-cancellation-policy`;
    };
}
